import React, { useEffect } from 'react'
import { useQuery } from '../../../routes'
import { AccessLevel } from '../../../queries/types'
import { Select } from 'ui'

export const useAccessLevelFilters = () => {
  const query = useQuery<{
    accessLevel: AccessLevel
    after?: string
    page?: string
  }>()
  const accessLevel =
    (query.search.accessLevel as AccessLevel | null) || AccessLevel.Admin
  useEffect(() => {
    if (query.search.accessLevel !== accessLevel) {
      query.set({
        ...query.search,
        after: undefined,
        page: undefined,
        accessLevel,
      })
    }
  }, [accessLevel, query])
  const setAccessLevel = (newAccessLevel: AccessLevel) => {
    query.set({
      ...query.search,
      after: undefined,
      page: undefined,
      accessLevel: newAccessLevel,
    })
  }
  return { accessLevel, search: query.search, setAccessLevel }
}

export const AccessLevelInput: React.FC = () => {
  const query = useQuery<{
    accessLevel: AccessLevel
    after?: string
    page?: string
  }>()
  const currentAccessLevel = query.search.accessLevel || AccessLevel.Admin

  const handleChange = (value: string) => {
    query.set({
      ...query.search,
      accessLevel: value as AccessLevel,
      after: undefined,
      page: undefined,
    })
  }

  const options = [
    { value: AccessLevel.Admin, label: AccessLevel.Admin },
    { value: AccessLevel.User, label: AccessLevel.User },
  ]

  return (
    <Select
      value={currentAccessLevel}
      onChange={handleChange}
      options={options}
      placeholder="Select access level"
    />
  )
}
